import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { colorPalette } from '~/themes/colors/colorPalette'
import { textStyleKeys } from '~/themes/textStyles'
import { CallTranscript } from '~/types/CallTranscript'

import { SectionHeader } from './SectionHeader'

interface OfficeTalkSpeedSectionProps {
  transcript: CallTranscript
}

export const OfficeTalkSpeedSection = ({
  transcript,
}: OfficeTalkSpeedSectionProps) => {
  const agentWordsPerMinute =
    transcript.ConversationCharacteristics.TalkSpeed.DetailsByParticipant.AGENT
      ?.AverageWordsPerMinute ?? 0

  return (
    <Flex
      flexDirection="column"
      width="100%"
      gap="1.5rem"
      justifyItems="stretch"
      height="7.125rem"
    >
      <SectionHeader
        title="Office Talk Speed"
        tooltipText="This shows the office's overall talk speed in words per minute (wpm). A normal range is 120-150 wpm, which is clear and easy to understand. Speeds below 100 wpm may feel too slow, while speeds above 160 wpm might be hard for patients to follow."
      />
      <Flex flexDirection="column" justifyContent="center" flex="1 0 0">
        <Text
          textStyle={textStyleKeys.H1}
          color={colorPalette.gray[1300]}
          marginTop="-1rem"
        >
          {agentWordsPerMinute}
        </Text>
        <Text textStyle={textStyleKeys.Body3}>Words Per Minute</Text>
      </Flex>
    </Flex>
  )
}
